// PromotionPricingSection.jsx

import React, { useState } from "react";
import "./PromotionPricingSection.css";

import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import ViewCarouselOutlinedIcon from "@mui/icons-material/ViewCarouselOutlined";
import Button from "@mui/material/Button";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOffer";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckout";
import ParticularsectionBuilder from './ParticularsectionBuilder';
import { Switch, FormControlLabel } from "@mui/material";
import CreateCampaign from "./CreateCampaign.jsx";
const pricingPlans = {
    branding: [
        {
            title: "In-App Popup",
            goal: "branding",
            subGoal: "awareness",
            type: "Promotion",
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",

            media: {
                image: {
                    price: 999,
                    duration: "30 Days",
                    resolution: "1080 × 1080 px",
                    format: "JPG / PNG",
                    maxSize: "5 MB"
                },

                video: {
                    price: 1499,
                    duration: "30 Days",
                    resolution: "1920 × 1080 px",
                    format: "MP4",
                    maxSize: "50 MB",
                    length: "30 Seconds"
                }
            },

            features: [
                "Popup Advertisement",
                "Image & Video Support",
                "1 Month Duration"
            ]
        },

        {
            title: "Banner",
            goal: "branding",
            subGoal: "awareness",
            type: "Display Ads",
            icon: <ViewCarouselOutlinedIcon />,
            buttonText: "Create",

            media: {
                image: {
                    price: 1499,
                    duration: "30 Days",
                    resolution: "1920 × 600 px",
                    format: "PNG / JPG",
                    maxSize: "5 MB"
                },

                video: {
                    price: 1999,
                    duration: "30 Days",
                    resolution: "1720 × 600 px",
                    format: "MP4",
                    maxSize: "50 MB",
                    length: "30 Seconds"
                }
            },

            features: [
                "Homepage Banner",
                "Image & Video Support",
                "30 Days"
            ]
        },

        {
            title: "Deals",
            goal: "branding",
            subGoal: "awareness",
            type: "Featured Deals",
            popular: true,
            icon: <LocalOfferOutlinedIcon />,
            buttonText: "Create",

            media: {
                image: {
                    price: 1999,
                    duration: "30 Days",
                    resolution: "1080 × 1080 px",
                    format: "PNG / JPG",
                    maxSize: "5 MB"
                },

                video: {
                    price: 2499,
                    duration: "30 Days",
                    resolution: "1920 × 1080 px",
                    format: "MP4",
                    maxSize: "50 MB",
                    length: "30 Seconds"
                }
            },

            features: [
                "Featured Deals",
                "Image & Video Support",
                "30 Days"
            ]
        },
        {
            title: "Checkout",
            goal: "branding",
            subGoal: "awareness",
            type: "Checkout Promotion",
            icon: <ShoppingCartCheckoutOutlinedIcon />,
            buttonText: "Create",

            media: {
                image: {
                    price: 1299,
                    duration: "30 Days",
                    resolution: "1080 × 1080 px",
                    format: "PNG / JPG",
                    maxSize: "5 MB"
                },

                video: {
                    price: 1799,
                    duration: "30 Days",
                    resolution: "1920 × 1080 px",
                    format: "MP4",
                    maxSize: "50 MB",
                    length: "30 Seconds"
                }
            },

            features: [
                "Checkout Page Promotion",
                "Image & Video Support",
                "30 Days"
            ]
        }
    ],

    leads: [
        {
            title: "100 Leads",
            goal: "leads",
            subGoal: "more_leads",
            type: "Lead Generation",
            price: 1000,
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            features: [
                "100 Verified Leads",
                "WhatsApp Leads",
                "30 Days"
            ]
        },

        {
            title: "200 Leads",
            goal: "leads",
            subGoal: "more_leads",
            type: "Lead Generation",
            price: 2000,
            popular: true,
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            features: [
                "200 Verified Leads",
                "WhatsApp Leads",
                "30 Days"
            ]
        },

        {
            title: "300 Leads",
            goal: "leads",
            subGoal: "more_leads",
            type: "Lead Generation",
            price: 3000,
            icon: <CampaignOutlinedIcon />,
            buttonText: "Create",
            features: [
                "300 Verified Leads",
                "WhatsApp Leads",
                "30 Days"
            ]
        }
    ],

    offers: [
        {
            title: "Menu Discounts",
            goal: "discount",
            subGoal: "menu",
            type: "Discount Campaign",
            price: 1999,
            icon: <LocalOfferOutlinedIcon />,
            buttonText: "Create",

            duration: "30 Days",

            features: [
                "Flat & Percentage Discounts",
                "Menu Category Discounts",
                "Campaign Analytics"
            ]
        },

        {
            title: "Coupons",
            goal: "discount",
            subGoal: "coupons",
            type: "Coupon Campaign",
            price: 1499,
            popular: true,
            icon: <StarBorderOutlinedIcon />,
            buttonText: "Create",

            duration: "30 Days",

            features: [
                "Coupon Code Support",
                "Limited Time Offers",
                "Redemption Analytics"
            ]
        },

        // Buy 1 Get 1
        {
            title: "Buy 1 Get 1",
            goal: "BOGO_DISCOUNT",
            subGoal: "menu",
            type: "BOGO Campaign",
            price: 2499,
            icon: <WorkspacePremiumOutlinedIcon />,
            buttonText: "Create",

            duration: "30 Days",

            features: [
                "Buy 1 Item & Get 1 Free",
                "Applicable Menu Items",
                "Campaign Analytics"
            ]
        },

        // Buy 2 Get 1
        {
            title: "Buy 2 Get 1",
            goal: "BOGO_DISCOUNT",
            subGoal: "menu",
            type: "BOGO Campaign",
            price: 3499,
            popular: true,
            icon: <WorkspacePremiumOutlinedIcon />,
            buttonText: "Create",

            duration: "30 Days",

            features: [
                "Buy 2 Items & Get 1 Free",
                "Applicable Menu Items",
                "Campaign Analytics"
            ]
        },

        // Buy 3 Get 1
        {
            title: "Buy 3 Get 1",
            goal: "BOGO_DISCOUNT",
            subGoal: "menu",
            type: "BOGO Campaign",
            price: 4499,
            icon: <WorkspacePremiumOutlinedIcon />,
            buttonText: "Create",

            duration: "30 Days",

            features: [
                "Buy 3 Items & Get 1 Free",
                "Applicable Menu Items",
                "Campaign Analytics"
            ]
        },
    ],

    digital: [
        {
            title: '32" Screen',
            goal: "branding",
            subGoal: "awareness",
            type: "Restaurant Display",
            icon: <ShoppingCartCheckoutOutlinedIcon />,
            buttonText: "Create",

            media: {
                image: {
                    price: 2999,
                    duration: "30 Days",
                    timeDuration: "1 Minute",
                    resolution: "1920 × 1080 px",
                    format: "PNG / JPG",
                    maxSize: "10 MB"
                },

                video: {
                    price: 3999,
                    duration: "30 Days",
                    timeDuration: "1 Minute",
                    resolution: "3840 × 2160 px",
                    format: "MP4",
                    maxSize: "100 MB",
                    length: "1 Minute"
                }
            },

            features: [
                '32" Full HD Screen',
                "Restaurant Indoor Display",
                "1 Minute Display Duration",
                "Monthly Campaign"
            ]
        },

        {
            title: '55" Screen',
            goal: "branding",
            subGoal: "awareness",
            type: "Shopping Mall Display",
            popular: true,
            icon: <DiamondOutlinedIcon />,
            buttonText: "Create",

            media: {
                image: {
                    price: 4999,
                    duration: "30 Days",
                    timeDuration: "1 Minute",
                    resolution: "3840 × 2160 px",
                    format: "PNG / JPG",
                    maxSize: "15 MB"
                },

                video: {
                    price: 5999,
                    duration: "30 Days",
                    timeDuration: "1 Minute",
                    resolution: "3840 × 2160 px",
                    format: "MP4",
                    maxSize: "150 MB",
                    length: "1 Minute"
                }
            },

            features: [
                '55" 4K Display',
                "Shopping Mall Screens",
                "1 Minute Display Duration",
                "Prime Customer Reach"
            ]
        },

        {
            title: '75" LED Video Wall',
            goal: "branding",
            subGoal: "awareness",
            type: "Premium Display",
            icon: <EmojiEventsOutlinedIcon />,
            buttonText: "Create",

            media: {
                image: {
                    price: 6999,
                    duration: "30 Days",
                    timeDuration: "1 Minute",
                    resolution: "7680 × 4320 px",
                    format: "PNG / JPG",
                    maxSize: "20 MB"
                },

                video: {
                    price: 8999,
                    duration: "30 Days",
                    timeDuration: "1 Minute",
                    resolution: "7680 × 4320 px",
                    format: "MP4",
                    maxSize: "250 MB",
                    length: "1 Minute"
                }
            },

            features: [
                '75" LED Video Wall',
                "8K Display Support",
                "1 Minute Display Duration",
                "High Traffic Locations"
            ]
        }
    ]
};

const Pricingsectionparticular = ({ feature, onCreateCampaign, hideParentBack,
    showParentBack, }) => {
    const getDefaultTab = () => {
        if (!feature) return "branding";

        switch (feature.title) {

            case "Branding Campaigns":
                return "branding";

            case "Lead Generation":
                return "leads";

            case "Digital Branding":
                return "digital";

            case "Percentage Discount":
                return "offers";

            case "Flat Discount":
                return "offers";

            case "Push Notifications":
                return "branding";

            case "Buy 1 Get 1":
                return "offers";

            case "WhatsApp Promotions":
                return "leads";

            case "Festival Offers":
                return "offers";
            case "Happy Hours":
                return "offers";
            default:
                return "branding";
        }
    };
    const [hidePricingSection, setHidePricingSection] = useState(false);
    const [activeTab, setActiveTab] = useState(getDefaultTab());
    const [mediaTypes, setMediaTypes] = useState({});
    const [leadPackage, setLeadPackage] = useState("100");
    const [showCreateCampaign, setShowCreateCampaign] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState(null);


    const handleMediaTypeChange = (cardKey, isVideo) => {
        setMediaTypes((prev) => ({
            ...prev,
            [cardKey]: isVideo ? "video" : "image",
        }));
    };

    const getPrice = (plan, cardKey) => {
        if (activeTab === "branding" || activeTab === "digital") {
            const currentMedia = mediaTypes[cardKey] || "image";

            return currentMedia === "video"
                ? plan.media.video.price
                : plan.media.image.price;
        }

        return plan.price;
    };
    console.log("Feature from PromotionFeatures :", feature);
    if (showCreateCampaign) {
        return (
            <CreateCampaign
                selectedPlan={selectedPlan}
                selectedFeature={{
                    goal: selectedPlan?.goal,
                    subGoal: selectedPlan?.subGoal,
                    title: selectedPlan?.title,
                }}
                onBack={() => setShowCreateCampaign(false)}
            />
        );
    }



    return (
        <>{!hidePricingSection && (

            <section className="maamaasPricingWrapper">
                <div className="maamaasPricingContainer">




                    {/* Sub Header */}

                    {!feature && (

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "left",
                                gap: "15px",
                                margin: "20px 0",
                                flexWrap: "wrap"
                            }}
                        >
                            {[
                                { id: "branding", label: "Branding" },
                                { id: "leads", label: "Leads" },
                                { id: "offers", label: "Offers" },
                                { id: "digital", label: "Digital Screens" }
                            ].map((tab) => (

                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    style={{
                                        padding: "8px 18px",
                                        borderRadius: "20px",
                                        border: activeTab === tab.id ? "none" : "1px solid #d1d5db",
                                        background: activeTab === tab.id ? "#4f46e5" : "#fff",
                                        color: activeTab === tab.id ? "#fff" : "#374151",
                                        cursor: "pointer",
                                        fontWeight: 600,
                                    }}
                                >
                                    {tab.label}
                                </button>

                            ))}
                        </div>

                    )}

                    <div className="maamaasPricingGrid">
                        {pricingPlans[activeTab]
                            .filter((plan) => {
                                if (!feature) return true;

                                switch (feature.title) {
                                    case "Branding Campaigns":
                                        return [
                                            "In-App Popup",
                                            "Banner",
                                            "Deals",
                                            "Checkout",
                                        ].includes(plan.title);

                                    case "Lead Generation":
                                        return plan.type === "Lead Generation";

                                    case "Digital Branding":
                                        return [
                                            '32" Screen',
                                            '55" Screen',
                                            '75" LED Video Wall',
                                        ].includes(plan.title);

                                    case "Flat Discount":
                                        return plan.title === "Coupons";

                                    case "Percentage Discount":
                                        return plan.title === "Menu Discounts";

                                    case "Festival Offers":
                                        return plan.title === "Coupons";

                                    case "Happy Hours":
                                        return plan.title === "Coupons";

                                    case "Buy 1 Get 1":
                                        return [
                                            "Buy 1 Get 1",
                                            "Buy 2 Get 1",
                                            "Buy 3 Get 1",
                                        ].includes(plan.title);

                                    case "WhatsApp Promotions":
                                        return plan.type === "Lead Generation";

                                    default:
                                        return true;
                                }
                            })
                            .map((plan, index) => {
                                const cardKey = `${activeTab}-${index}`;
                                const currentMedia = mediaTypes[cardKey] || "image";

                                return (
                                    <div
                                        key={index}
                                        className={`maamaasPricingCard ${plan.popular ? "maamaasPricingCardFeatured" : ""
                                            }`}
                                    >
                                        {plan.popular && (
                                            <div className="maamaasPricingPopularTag">
                                                ★ Most Popular
                                            </div>
                                        )}

                                        <div className="maamaasPricingCardTop">
                                            <div className="maamaasPricingIconBox">
                                                {plan.icon}
                                            </div>
                                            <h4
                                                className="maamaasPricingPlanName"
                                                style={{
                                                    margin: 0,
                                                    fontSize: "20px",
                                                    fontWeight: "700",
                                                    color: "#1f2937",
                                                }}
                                            >
                                                {plan.title}
                                            </h4>
                                            {/* <span className="maamaasPricingType">
                                            {plan.type}
                                        </span> */}
                                        </div>

                                        {/* Title */}


                                        {/* Image / Video Buttons */}
                                        {(activeTab === "branding" || activeTab === "digital") && (
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "10px",
                                                    marginBottom: "15px",
                                                    marginTop: "10px"
                                                }}
                                            >
                                                <Button
                                                    variant={
                                                        currentMedia === "image"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    size="small"
                                                    onClick={() =>
                                                        handleMediaTypeChange(cardKey, false)
                                                    }
                                                    sx={{
                                                        textTransform: "none",
                                                        borderRadius: "20px",
                                                        minWidth: "90px",
                                                        backgroundColor:
                                                            currentMedia === "image"
                                                                ? "#e66d33"
                                                                : "transparent",
                                                        borderColor: "#e66d33",
                                                        color:
                                                            currentMedia === "image"
                                                                ? "#fff"
                                                                : "#e66d33",
                                                        "&:hover": {
                                                            backgroundColor:
                                                                currentMedia === "image"
                                                                    ? "#d85f28"
                                                                    : "#fff3ec",
                                                            borderColor: "#e66d33",
                                                        },
                                                    }}
                                                >
                                                    🖼 Image
                                                </Button>

                                                <Button
                                                    variant={
                                                        currentMedia === "video"
                                                            ? "contained"
                                                            : "outlined"
                                                    }
                                                    size="small"
                                                    onClick={() =>
                                                        handleMediaTypeChange(cardKey, true)
                                                    }
                                                    sx={{
                                                        textTransform: "none",
                                                        borderRadius: "20px",
                                                        minWidth: "90px",
                                                        backgroundColor:
                                                            currentMedia === "video"
                                                                ? "#e66d33"
                                                                : "transparent",
                                                        borderColor: "#e66d33",
                                                        color:
                                                            currentMedia === "video"
                                                                ? "#fff"
                                                                : "#e66d33",
                                                        "&:hover": {
                                                            backgroundColor:
                                                                currentMedia === "video"
                                                                    ? "#d85f28"
                                                                    : "#fff3ec",
                                                            borderColor: "#e66d33",
                                                        },
                                                    }}
                                                >
                                                    🎥 Video
                                                </Button>
                                            </div>
                                        )}
                                        <div
                                            style={{
                                                margin: "15px 0",
                                            }}
                                        >
                                            {/* <h4
                                            className="maamaasPricingPlanName"
                                            style={{
                                                margin: 0,
                                                textAlign: "center"
                                            }}
                                        >
                                            {plan.title}
                                        </h4> */}
                                        </div>
                                        {/* Price */}
                                        <div className="maamaasPricingAmountRow">
                                            <span className="maamaasPricingCurrency">₹</span>

                                            <span className="maamaasPricingAmount">
                                                {getPrice(plan, cardKey)}
                                            </span>

                                            <span className="maamaasPricingMonth">
                                                /mo
                                            </span>
                                        </div>

                                        {/* Resolution */}
                                        {(activeTab === "branding" || activeTab === "digital") && (
                                            <div className="mediaSpecs">
                                                <ul className="maamaasPricingFeatureList">
                                                    <li>
                                                        <CheckCircleRoundedIcon />
                                                        Resolution :
                                                        {currentMedia === "image"
                                                            ? plan.media.image.resolution
                                                            : plan.media.video.resolution}
                                                    </li>
                                                </ul>
                                            </div>
                                        )}

                                        {/* Features */}
                                        <ul className="maamaasPricingFeatureList">
                                            {plan.features.map((feature, idx) => (
                                                <li key={idx}>
                                                    <CheckCircleRoundedIcon />
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>

                                        <button
                                            className="maamaasPricingButton"
                                            onClick={() => {

                                                const planData = {
                                                    category: activeTab,
                                                    title: plan.title,
                                                    plan,
                                                    goal: plan.goal,
                                                    subGoal: plan.subGoal,
                                                };

                                                console.log("Selected Plan :", planData);

                                                setSelectedPlan(planData);

                                                hideParentBack?.();

                                                // 👇 This is missing
                                                setShowCreateCampaign(true);
                                            }}
                                        >
                                            {plan.buttonText}
                                        </button>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            </section>
        )}
            <ParticularsectionBuilder
                selectedPlan={selectedPlan}
                activeTab={activeTab}
                hidePricingSection={() => setHidePricingSection(true)}
                hideParentBack={hideParentBack}
            />

        </>
    );

};
const imageSpecs = {
    resolution: "1080 × 1080 px",
    format: "JPG / PNG",
    size: "5 MB",
    duration: "30 Days"
};
const videoSpecs = {
    resolution: "1920 × 1080 px",
    format: "MP4",
    size: "50 MB",
    duration: "30 Days",
    length: "30 Seconds"
};
const digitalImageSpecs = {
    resolution: "1920 × 1080",
    format: "PNG / JPG",
    size: "10 MB",
    duration: "30 Days"
};
const digitalVideoSpecs = {
    resolution: "3840 × 2160",
    format: "MP4",
    size: "100 MB",
    duration: "30 Days",
    length: "60 Seconds"
};
export default Pricingsectionparticular;